import { Constants } from "../constants/constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from "../utils/utils";

@Injectable({
  providedIn: "root",
})
export class DireccionService {
  constructor(private http: HttpClient, private utils: Utils) {}

  public postDireccion(direccion): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_DIRECCION;
    //alert(url);
    return this.http.post<any>(url, direccion).pipe(
      catchError((err) => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Dirección",
            text: "Verifique la informacion ingresada.",
            icon: "error",
          });
        }
        return throwError(err);
      })
    );
  }

  public putDireccion(direccion): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_DIRECCION;
    return this.http.put<any>(url, direccion).pipe(
      catchError((err) => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Dirección",
            text: "Error actualizando información de la dirección.",
            icon: "error",
          });
        }

        return throwError(err);
      })
    );
  }

  public deleteDireccion(direccion): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_DIRECCION + "/" + direccion;
    return this.http.delete<any>(url).pipe(
      catchError((err) => {
        Swal.fire({
          title: "Error Dirección",
          text: "Error eliminado información de la dirección.",
          icon: "error",
        });
        return throwError(err);
      })
    );
  }
}
